import type { CpuThresholds } from '../duel/cpu'
import type { PlayerPublic } from '../protocol'
import type { GameState } from './engine'

/** The house player of "You can't beat me!". A real `players` row exists for it on the server. */
export const CPU_ID = 'cpu:xox-9000'

export const CPU_PLAYER: PlayerPublic = {
  id: CPU_ID,
  nickname: 'XOX-9000',
  avatar: '🤖',
  color: 'violet',
}

/** A human who lasts this few plies gets laughed at. */
export const CPU_QUICK_WIN_PLIES = 7
/** A human who lasts this many plies earns applause. */
export const CPU_LONG_FIGHT_PLIES = 15
export const XOX_CPU_THRESHOLDS: CpuThresholds = {
  quickPlies: CPU_QUICK_WIN_PLIES,
  longPlies: CPU_LONG_FIGHT_PLIES,
}

/**
 * House rule for human-first games. The empty board is a forced win for whoever opens on an edge
 * (see solver.test.ts), so when the human starts these four cells are off limits for the first
 * mark. XOX-9000 refuses them by policy; the human is refused by the server and the board.
 */
export const CPU_EDGE_CELLS: readonly number[] = [1, 3, 5, 7]

export function isBlockedOpening(game: GameState, cell: number): boolean {
  return game.moveCount === 0 && CPU_EDGE_CELLS.includes(cell)
}
